// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // Detects the user's language
import ChainedBackend from "i18next-chained-backend";
import HttpApi from 'i18next-http-backend'; // Import the http-backend for loading external resources
import resourcesToBackend from "i18next-resources-to-backend"; 

// Custom backend che mergia remoto + locale
const mergedBackend = {
    type: 'backend',
    init: () => {},
    read: async (language, namespace, callback) => {
        try {
            // 1. Carica il locale come base
            let localData = {};
            try {
                localData = (await import(`./locales/${language}.json?`)).default;
            } catch (err) {
                console.warn(`Local file for ${language} not found`);
            }

            // 2. Prova a caricare il remoto e mergarlo
            if (process.env.REACT_APP_I18N_JSON_URL) {
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_I18N_JSON_URL}${language}.json`
                    );
                    if (response.ok) {
                        const remoteData = await response.json();
                        // Mergia: remoto sovrascrive locale dove esiste
                        const merged = { ...localData, ...remoteData };
                        callback(null, merged);
                        return;
                    }
                } catch (err) {
                    console.warn(`Remote file for ${language} failed to load`);
                }
            }

            // 3. Se remoto non disponibile, usa il locale
            callback(null, localData);
        } catch (error) {
            console.error(`Failed to load translations for ${language}:`, error);
            callback(error);
        }
    }
};

// Initialize i18n
i18n
    .use(mergedBackend) // Custom backend che mergia remoto + locale
    .use(LanguageDetector) // Automatically detect the user's language
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        fallbackLng: () => ['it'], // Se tutto fallisce, fallback su italiano
        interpolation: {
            escapeValue: false, // React already escapes the values to prevent XSS
        },
        detection: {
        // Order of language detection
        order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        
        // Cache the user's language in local storage
        caches: ['localStorage'],

        // Define how to detect the language from local storage
        lookupLocalStorage: 'i18nextLng', // The key in local storage where the language is stored
        },
        load:"languageOnly"
    });

export default i18n;